import { render, staticRenderFns } from "./HeaderRight.vue?vue&type=template&id=968d7f36&"
import script from "./HeaderRight.vue?vue&type=script&lang=js&"
export * from "./HeaderRight.vue?vue&type=script&lang=js&"
import style0 from "./HeaderRight.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports